import { useGetDataPDF } from "@/api/generate-hpdb";
import { useFDTs } from "@/api/opm-fdt";
import { P } from "@/components/ui/typography";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function MapSummary() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: dataPDF } = useGetDataPDF({
    rfsId: id,
  });
  const { data: opmFdts } = useFDTs({
    rfsId: id,
  });

  return (
    <div className="mx-auto mt-2 w-fit text-[8px]">
      <div className="border border-b-0 border-gray-200 p-1">
        <P className="text-center">DESIGN SUMMARY</P>
      </div>

      <div className="border border-b-0 border-gray-200 p-1">
        <P className="text-center">
          {dataPDF?.clusterName} {"RT " + dataPDF?.rt}{" "}
          {dataPDF?.rt && dataPDF?.rw
            ? ` & RW ${dataPDF.rw}`
            : "RW " + dataPDF?.rw}{" "}
          <br /> {dataPDF?.district}
        </P>
      </div>

      <div>
        <TotalHP totalHpRfs={dataPDF?.totalHpRfs} />
        <TotalFAT total={dataPDF?.totalFat} />
        <TotalFDT total={opmFdts?.totalElements} />
      </div>
    </div>
  );
}

function TotalHP({ totalHpRfs }: { totalHpRfs?: number }) {
  return (
    <div className="flex justify-between">
      <P className="flex-[3_3_0%] border border-b-0 border-gray-200 p-1 text-center">
        Total HP
      </P>
      <P className="flex-1 border border-b-0 border-l-0 border-gray-200 p-1 text-center">
        {totalHpRfs ?? "-"}
      </P>
    </div>
  );
}

function TotalFAT({ total }: { total?: number }) {
  return (
    <div className="flex justify-between">
      <P className="flex-[3_3_0%] border border-b-0 border-gray-200 p-1 text-center">
        Total FAT
      </P>
      <P className="flex-1 border border-b-0 border-l-0 border-gray-200 p-1 text-center">
        {total ?? "-"}
      </P>
    </div>
  );
}

function TotalFDT({ total }: { total?: number }) {
  return (
    <div className="flex justify-between">
      <P className="flex-[3_3_0%] border border-gray-200 p-1 text-center">
        Total FDT
      </P>
      <P className="flex-1 border border-l-0 border-gray-200 p-1 text-center">
        {total ?? "-"}
      </P>
    </div>
  );
}
